import {
  SimpleForm,
  NumberInput,
  Toolbar,
  SaveButton,
  Button,
  required,
  maxValue,
} from "react-admin";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useNotify } from "react-admin";
import { COUNT_AIRBAG_MAX, COUNT_BINS_MAX, integerOnly } from "../validators";

export const ClientInventoryCreate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const notify = useNotify();
  const clientId = new URLSearchParams(search).get("clientId")!;

  const onSubmit = async (values: any) => {
    const token = localStorage.getItem("kc_token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/client-inventory/${clientId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(values),
        }
      );
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || res.statusText);
      }
      notify("Inventaire créé", { type: "success" });
      navigate(`/client-inventory/details/${clientId}`);
    } catch (err: any) {
      notify(err.message || "Erreur lors de la création", { type: "error" });
    }
  };

  return (
    <>
      <h2>Ajouter un inventaire client</h2>
      <SimpleForm
        onSubmit={onSubmit}
        toolbar={
          <Toolbar>
            <SaveButton />
            <Button
              component={Link}
              variant="outlined"
              color="secondary"
              size="large"
              to={`/client-inventory/details/${clientId}`}
              sx={{ ml: 2, pl: 4 }}
            >
              Annuler
            </Button>
          </Toolbar>
        }
      >
        <NumberInput
          source="fullBinsCount"
          label="Caisses pleines"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <NumberInput
          source="emptyBinsCount"
          label="Caisses vides"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <NumberInput
          source="airbagsCount"
          label="Nb airbag en vrac"
          validate={[
            required("La quantité d'airbag en vrac est requise"),
            maxValue(COUNT_AIRBAG_MAX, `Maximum ${COUNT_AIRBAG_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
      </SimpleForm>
    </>
  );
};
